import { FORM } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useFormSubmissionFilter } from '../../hooks/useFormSubmissionFilter';
import { useOperatorOptions } from '../../hooks/useOperatorOptions';
import { Select } from 'foundations-components/transitional/components/Select';
import ConditionError from '../common/ConditionError';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import EditorConditionAsset from './EditorConditionAsset';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import { NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import EditorFormSubmissionRelatedConditionsGroup from './EditorFormSubmissionRelatedConditionsGroup';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import ConditionBox from '../common/ConditionBox';
import { INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT } from '../../constants/inlineLayout';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FORM_NOT_FILLED_OUT = 'FormNotFilledOut';
const EditorFormSubmissionRelatedConditionsGroupResponsive = props => {
  var _condition$field2;
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    inputUse
  } = props;
  const {
    width
  } = useElementSize();
  const {
    getTrackerInstance,
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange,
    onFieldConditionValueAndOperatorChange
  } = useFieldConditionChange(FORM, conditionPath, condition);
  const {
    statusCondition,
    refinementConditionsEmptyValue
  } = useFormSubmissionFilter(condition, onFieldConditionValueChange);
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(FORM, statusCondition.field, statusCondition);
  const onSelectedOptionChange = evt => {
    var _getTrackerInstance, _condition$field;
    const operatorName = evt.target.value.value;

    // delete "Number of Submissions" refinement when "Contact has not filled out form" is selected
    if (operatorName === FORM_NOT_FILLED_OUT && condition.numberRefinement) {
      onFieldConditionValueAndOperatorChange(getOperatorByName(operatorName), condition.remove(NUMBER_REFINEMENT));
    } else {
      onFieldConditionOperatorChange(getOperatorByName(operatorName));
    }
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: FORM,
      type: (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.type,
      version: '2'
    });
  };
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorFormSubmissionRelatedConditionsGroup, Object.assign({}, props));
  }

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.userHasNoAccess;
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      condition: condition,
      onConditionDelete: () => onConditionDelete(conditionPath),
      hideChangeFieldButton: true,
      isFilterBranch: true,
      filterFamily: FORM,
      deleteButtonLayoutStyle: "inline",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: FORM,
          onAssetChange: onFieldConditionFieldChange,
          inputUse: inputUse
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(Select, {
          "data-selenium-info": dataSeleniumInfo,
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: userHasNoAccess,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          value: condition.constructor.toString(),
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
        })
      })]
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      inputUse: inputUse,
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: FORM,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue,
      hasInlineLayout: true
    })]
  });
};
export default EditorFormSubmissionRelatedConditionsGroupResponsive;